<!--首页-->
<template>
  <div class="home-page mt16">
    <div
      class="party-building-img hover-inter-active"
      @click="onMenuItem('/special-column', '专题专栏')"
      v-for="item in themeList"
      :key="item.id"
    >
      <img :src="path + item.imagePath" alt="" />
    </div>
    <div class="news space-between">
      <div class="left">
        <el-carousel>
          <el-carousel-item v-for="(item, i) in bannerList" :key="i">
            <div class="carouse-img" @click="onMenuLinkItem(item.url)">
              <img v-if="item.imagePath" :src="path + item.imagePath" alt="" />
              <img src="../assets/images/img_default.webp" v-else alt="" />
              <div class="flex img-title">
                <p class="text_overflow" :title="item.title">
                  {{ item.title }}
                </p>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="right">
        <div class="space-between mytab">
          <div class="tag">最新动态</div>
          <el-link
            :underline="false"
            @click="toMore({ title: '首页', tag: '最新动态' })"
            class="hover-inter-active"
          >
            更多 <i class="el-icon-d-arrow-right"></i>
          </el-link>
        </div>
        <ul class="news-ul-li" style="height: 442px; margin-bottom: 0">
          <li
            class="space-between"
            v-for="(item, i) in newsPresslList.slice(0, 11)"
            :key="i"
            @click="
              toDetails(
                {
                  id: item.id,
                  title: '首页',
                  tag: '最新动态'
                },
                item.linkTo
              )
            "
          >
            <!-- @click="toDetails({ id: item.id, ...item.query })" -->
            <p class="text_overflow" :title="item.title">{{ item.title }}</p>
            <span>{{
              item.publishedDate
                ? item.publishedDate.split(' ')[0]
                : item.createdDate.split(' ')[0]
            }}</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="notice space-between">
      <img src="../assets/images/img_5.webp" alt="" class="lb" />
      <span class="font20 el-link">通知公告</span>
      <div class="notice-carousel">
        <el-carousel height="28px" indicator-position="none" arrow="never">
          <el-carousel-item v-for="(item, i) in announcementlList" :key="i">
            <div
              class="space-between pointer font20"
              @click="
                toDetails(
                  {
                    id: item.id,
                    title: '中心动态',
                    tag: tabname
                  },
                  item.linkTo
                )
              "
            >
              <p>
                {{ item.title }}
              </p>
              <span>{{
                item.publishedDate
                  ? item.publishedDate.split(' ')[0]
                  : item.createdDate.split(' ')[0]
              }}</span>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <el-link
        :underline="false"
        @click="
          toMore({
            title: '中心动态',
            tag: '通知公告',
            key: 'news.announcement.id'
          })
        "
        class="hover-inter-active"
      >
        更多 <i class="el-icon-d-arrow-right"></i>
      </el-link>
    </div>
    <public-service></public-service>
  </div>
</template>
<script>
import {
  getArticleList,
  getlatest,
  getCategory,
  getSlideList,
  getThemeList,
  slideShowList,
  getKey
} from '@/api/index'
import publicService from '../components/home/public-service.vue'
import { mapState } from 'vuex'

export default {
  name: 'home',
  data() {
    return {
      carouselList: [],
      newsPresslList: [],
      announcementlList: [],
      themeList: [],
      category: [],
      bannerList: [],
      tabname: ''
    }
  },
  components: { publicService },
  computed: {
    ...mapState(['menuArr'])
  },
  activated() {
    this.getArticleList()
  },
  created() {
    this.getCategory()
    this.getlatest()
    this.slideShowList()
    this.getThemeList()
    this.getKey()
    this.getSlideShowList()
  },
  methods: {
    // 获取首页轮播动态
    slideShowList() {
      slideShowList()
        .then((res) => {
          this.bannerList = res.list
        })
        .finally(() => {})
    },
    getKey() {
      // 动态获取法规文件的tab
      getKey({ key: 'news.announcement.id' })
        .then((res) => {
          this.tabname = res.name
        })
        .finally(() => {})
    },
    // 获取最新动态的分类列表
    getCategory() {
      getCategory()
        .then((res) => {
          this.category = res.list
        })
        .finally(() => {})
    },
    getThemeList() {
      getThemeList()
        .then((res) => {
          this.themeList = res.list
        })
        .finally(() => {})
    },
    // 跳转本地
    onMenuItem(path, tag) {
      this.$store.commit('SET_TABS', {
        children: [{ tag: '党建专题', key: 'special.column.id' }]
      })
      this.$router.push({
        path,
        query: { title: '首页', tag, key: 'special.column.id' }
      })
    },

    // 跳转第三方链接
    onMenuLinkItem(url) {
      window.open(url, '_blank')
    },
    getArticleList() {
      getArticleList({ key: 'news.announcement.id', page: 0, size: 5 })
        .then((res) => {
          // 通知公告
          this.announcementlList = res.list
        })
        .finally(() => {})
    },
    // 最新动态数据
    getlatest() {
      getlatest()
        .then((res) => {
          res.list.forEach((item, i) => {
            const category = this.category.find(
              (categoryitem) => item.pid == categoryitem.id
            )
            item['query'] = {
              title: category.title.split('-')[0],
              tag: category.title.split('-')[1]
            }
          })
          this.newsPresslList = res.list
        })
        .finally(() => {})
    },
    // 轮播动态
    getSlideShowList() {
      getSlideList()
        .then((res) => {
          this.carouselList = res.list
            .filter((item) => item.status === true)
            .sort((a, b) => a.orderNo - b.orderNo) // 根据 orderNo 升序排序
        })
        .finally(() => {})
    },
    toDetails(query, linkTo) {
      if (linkTo) {
        window.open(linkTo, '_blank')
      } else {
        this.$router.push({ path: '/details', query })
      }
    },
    // 点击更多
    toMore(query) {
      this.$router.push({
        path: '/document',
        query: query
      })
      if (query.tag == '最新动态') {
        this.$store.commit('SET_TABS', {
          children: [{ tag: query.tag }]
        })
      } else {
        const arr = this.menuArr.find((item) => item.title == '中心动态')
        this.$store.commit('SET_TABS', {
          children: arr.children
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.home-page {
  width: 100%;
  flex: 1;

  .party-building-img {
    width: 100%;
    height: 140px;

    img {
      width: 100%;
      height: 100%;
    }
  }
  .news {
    width: 100%;
    height: 492px;
    margin: 16px 0;
    .left {
      margin-right: 16px;
      min-width: 620px;
      height: 100%;
      position: relative;
      flex: 1;
      ::v-deep .el-carousel__container {
        height: 492px !important;
      }
      ::v-deep .el-carousel__indicator.is-active button {
        background-color: #fff;
      }
      ::v-deep .el-carousel__indicators--horizontal {
        left: calc(100% - 140px);
        width: max-content;
        bottom: 0;
        transform: translateX(0);
        padding: 4px 4px;
      }

      ::v-deep .el-carousel__button {
        width: 14px;
        height: 14px;
        border-radius: 50%;
        border: 1px solid #fff;
        background-color: #ffffff40;
        border: none;
      }
      .carouse-img {
        cursor: pointer;
        img {
          height: 492px;
          width: 100%;
          object-fit: cover;
        }
        .img-title {
          height: 46px;
          width: 100%;
          font-size: 18px;
          color: #fff;
          line-height: 46px;
          padding: 0 260px 0 24px;
          background: #00050a60;
          position: absolute;
          bottom: 0;
          z-index: 100;
          .text_overflow {
            margin-bottom: 0;
            min-width: 260px;
          }
        }
      }
    }
    .right {
      width: 470px;
      height: 100%;
    }
  }

  .notice {
    width: 100%;
    height: 54px;
    background: url(../assets/images/img_4.webp) no-repeat;
    background-size: 100% 100%;
    object-fit: fill;
    margin-bottom: 16px;
    padding: 0 26px;
    align-items: center;
    .lb {
      width: 28px;
      height: 28px;
    }
    .notice-carousel {
      height: 28px;
      flex: 1;
      align-items: center;
      line-height: 28px;
      padding: 0 20px 0 10px;

      p,
      span {
        color: #333333;
      }
    }
    .el-link {
      color: #ff8c00;
    }
  }
  .font20 {
    font-size: 20px;
  }
}
@media screen and (max-width: 768px) {
  .home-page {
    .party-building-img {
      width: 100%;
      height: 100px;
    }
    .news {
      height: auto;
      flex-direction: column;
      margin-bottom: 16px;

      .left {
        width: 100%;
        min-width: 100%;
        margin-right: 0px;
        margin-bottom: 16px;
        ::v-deep .el-carousel__container {
          height: 400px !important;
        }

        ::v-deep .el-carousel__indicator.is-active button {
          background-color: #fff;
        }
        ::v-deep .el-carousel__indicators--horizontal {
          left: calc(100% - 100px);
          height: 46px;
          display: flex;
          align-items: center;
        }

        ::v-deep .el-carousel__button {
          width: 10px;
          height: 10px;
        }
        .carouse-img {
          cursor: pointer;
          .img-title {
            font-size: 18px;
            padding: 0 260px 0 16px;
            .text_overflow {
              min-width: 200px;
            }
          }
        }
      }
      .right {
        width: 100%;
        height: 490px;
      }
    }
    .notice {
      margin: 0 0 16px;
      padding: 0 16px;
    }
  }
}
</style>
